import LogRocket from 'logrocket';
import template from './settingsControls.html';

/* @ngInject */
function settingsControlsCtrl(growl, CameraService, ModalService) {
  const vm = this;

  vm.showOverlay = true;

  vm.$onInit = $onInit;
  vm.resetCameraModal = resetCameraModal;
  vm.restartCameraModal = restartCameraModal;
  vm.autoFocus = autoFocus;
  vm.toggleOverlayVisibility = toggleOverlayVisibility;
  vm.toggleVideoAction = toggleVideoAction;

  function $onInit() {
    vm.camera = CameraService.getCamera(vm.panelId, vm.cameraId);
  }

  function resetCamera() {
    let growlMessage = growl.info(`Resetting ${vm.camera.name}...`, {
      disableCloseButton: true
    });
    CameraService.resetCamera(vm.cameraId)
      .then(() => {
        if (growlMessage) {
          growlMessage.destroy();
        }
        growlMessage = growl.success(`${vm.camera.name} was reset`);
      })
      .catch((res) => {
        if (growlMessage) {
          growlMessage.destroy();
        }
        const error = `Error resetting ${vm.camera.name}`;
        growlMessage = growl.error(res.error, { title: error });
        LogRocket.track(error);
      });
  }

  function restartCamera() {
    let growlMessage = growl.info(`Restarting ${vm.camera.name}...`, {
      disableCloseButton: true
    });
    CameraService.restartCamera(vm.cameraId)
      .then(() => {
        if (growlMessage) {
          growlMessage.destroy();
        }
        growlMessage = growl.success(`${vm.camera.name} was restarted`);
      })
      .catch((res) => {
        if (growlMessage) {
          growlMessage.destroy();
        }
        const error = `Error restarting ${vm.camera.name}`;
        growlMessage = growl.error(res.error, { title: error });
        LogRocket.track(error);
      });
  }


  function resetCameraModal() {
    return ModalService.confirmationModal({
      modalTitle: 'Reset Camera',
      optionalWarning: 'This will overwrite all of the current settings on the camera to their default values.',
      selectionCriteria: `"${vm.camera.name}" will be reset.`,
      onConfirm: resetCamera,
      danger: true,
    });
  }

  function restartCameraModal() {
    return ModalService.confirmationModal({
      modalTitle: 'Restart Camera',
      optionalWarning: 'This will restart the camera and can take 60 to 120 seconds to complete.',
      selectionCriteria: `"${vm.camera.name}" will be restarted.`,
      onConfirm: restartCamera
    });
  }


  function autoFocus() {
    let growlMessage = growl.info(`Auto-focusing ${vm.camera.name}...`, {
      disableCloseButton: true
    });
    CameraService.autoFocus(vm.cameraId)
      .then(() => {
        if (growlMessage) {
          growlMessage.destroy();
        }
        growlMessage = growl.success(`${vm.camera.name} has been auto-focused`);
      })
      .catch((res) => {
        if (growlMessage) {
          growlMessage.destroy();
        }
        const error = `Unable to auto-focus ${vm.camera.name}`;
        growlMessage = growl.error(res.error, { title: error });
        LogRocket.track(error);
      });
  }

  function toggleOverlayVisibility() {
    vm.showOverlay = !vm.showOverlay;
    vm.toggleOverlayAction({ showOverlay: vm.showOverlay });
  }

  function toggleVideoAction() {
    vm.toggleVideo({ stop: vm.playingVideo });
  }
}

export default {
  name: 'settingsControls',
  template,
  controllerAs: 'SettingsControlsCtrl',
  controller: settingsControlsCtrl,
  bindings: {
    playingVideo: '<',
    cameraId: '<',
    panelId: '<',
    activeZone: '<',
    toggleVideo: '&',
    toggleOverlayAction: '&?'
  }
};
